import React from 'react'
import { isMobile } from 'react-device-detect'
import { useTranslations } from 'next-intl'

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange
}: {
  currentPage: number
  totalPages: number
  onPageChange: any
}) => {
  const t = useTranslations('')
  const maxPages = 10

  const getPagesToShow = () => {
    const maxPagesToShow = isMobile ? 2 : maxPages

    if (totalPages <= maxPagesToShow) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    } else {
      if (currentPage <= maxPagesToShow - 1) {
        return [
          ...Array.from({ length: maxPagesToShow }, (_, i) => i + 1),
          '...',
          totalPages
        ]
      } else if (currentPage >= totalPages - (maxPagesToShow - 2)) {
        return [
          1,
          '...',
          ...Array.from(
            { length: maxPagesToShow },
            (_, i) => totalPages - (maxPagesToShow - 1) + i
          )
        ]
      } else {
        let response = [
          1,
          '...',
          currentPage - 1,
          currentPage,
          currentPage + 1,
          '...',
          totalPages
        ]

        if (isMobile) {
          response = [
            1,
            '...',
            currentPage,
            '...',
            totalPages
          ]
        }

        return response
      }
    }
  }

  return (
    <div className='pagination-wrap hstack gap-2'>
      <button
        className={`page-item btn pagination-button pagination-prev ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={() => onPageChange(currentPage - 1)}
      >
        {t('Previous')}
      </button>
      <ul className='pagination listjs-pagination mb-0'>
        {getPagesToShow().map((page, index) => (
          <li
            key={index}
            className={`page-item ${page === currentPage ? 'active' : ''}`}
            onClick={() => page !== '...' && onPageChange(page)}
          >
            <span className='page-link'>{page}</span>
          </li>
        ))}
      </ul>
      <button
        className={`page-item btn pagination-button pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}
        onClick={() => onPageChange(currentPage + 1)}
      >
        {t('Next')}
      </button>
    </div>
  )
}

export default Pagination
